// Customizable Area Start
import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { makeApiMessage } from "../../../components/src/common";
import {
  CustomerList,
  CustomerSearchResponse,
  ServiceDropdownList,
} from "./utils";
import { IMyUser } from "../../../blocks/navigationmenu/src/utils";
import {
  CustomerDataType,
  IlaundryOrder,
  StoreOrderItem,
  UniqueCombination,
} from "../../../components/src/Interface";
import {
  CustomEnums,
  debounce,
  getCustomEnumName,
  navigateTo,
  conditionalString,
  updateAccountType,
} from "../../../blocks/utilities/src/CustomBlockHelpers";
import { InvoiceRawData } from "../..//print/src/PrintController";
import { PaymentTransactionData } from "../../Payments/src/PaymentModalController.web";
import { toString } from "lodash";
import { ORDER_TYPES } from "../../../blocks/AljabrStore/src/AljabrStore2Controller.web";
import { getStorageData } from "framework/src/Utilities";
// Customizable Area End

// Customizable Area Start
export const configJSON = require("./config");
const serviceDropList = [
  {
    value: "pick_up",
    option: "Pick up",
  },
  {
    value: "delivery",
    option: "Delivery",
  },
  {
    value: "pick_up_and_delivery",
    option: "Pick up and Delivery",
  },
];
export interface B2bCustomer {
  id: string;
  type: string;
  attributes: {
    id: number;
    name: string;
    email: string;
    full_phone_number: string;
    order: IlaundryOrder;
  };
  priceList?: { isActive: boolean };
}

interface IGoldenPointItem {
  id: string;
  attributes: {
    golden_point: {
      attributes: {
        base_points: number;
        bonus_points: number;
      };
    };
    free_wash_quentity: number;
    quantity: number;
    free_wash_products: { data: any[] };
    name: string;
    price: string;
    final_price: string;
    total_points: number;
  };
  type: string;
}
// Customizable Area End

export interface Props {
  // Customizable Area Start
  navigation: any;
  id: string;
  currentUser: IMyUser | undefined;
  selectedMainTab: string;
  resetAllProductQuantities: () => void;
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  selectedPickUpDate: Date | null;
  selectedDeliveryDate: Date | null;
  cartTotalOpen: boolean;
  countryCodeInput: string;
  customerPhoneNumber: string;
  customerList: Array<CustomerList>;
  // cartProducts:Array;
  cartProducts: IlaundryOrder[];
  customerData: CustomerDataType | B2bCustomer | null;
  openAddCustomerModal: boolean;
  errorSnackbarOpen: boolean;
  errorMessage: string;
  viewCustomerPopup: boolean;
  isEditCustomerForm: boolean;
  serviceDropdownList: Array<ServiceDropdownList>;
  selectedServiceValue: string;
  isQuickDropCount: number;
  isQuickDropOrder: boolean;
  order: IlaundryOrder | undefined;
  paymentModalVisible: boolean;
  paymentClicked: boolean;
  notesTextArea: string;
  saveForFuture: boolean;
  orderSummaryVisible: boolean;
  placedOrder: IlaundryOrder | undefined;
  isPrmocodeApplied: boolean;
  prefrenceCustomerNumber: string;
  customerId: string;
  editId?: string;
  isLoading: boolean;
  isShoppingcartLoading: boolean;
  isB2bActive: boolean;
  checkContractSuccessMsg: string;
  isLinked: boolean;
  isLinkeds: boolean;
  searchedCustomer: CustomerList | null;
  isCountryCodeDisabled: boolean;
  currentInputType: "text" | "number" | "employee_id" | "empty";
  customerNameSearchResults: Array<CustomerList>;
  addPromotionsModalVisible: boolean;
  // Customizable Area End
}

interface SS {
  // Customizable Area Start
  // Customizable Area End
}

export default class StoreCartController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  searchCustomerApiMessageId: string = "";
  searchCustomerDataApiMessageId: string = "";
  createQuickdropOrderId: string = "";
  getOrderDetailsAPIcallID: string = "";
  generateOrderInvoiceCallId: string = "";
  getRawOrderInvoiceDataCallId: string = "";
  placedOrderRawData: InvoiceRawData | null = null;
  checkContractAvailablityApiMessageId: string = "";
  getRemainBalanceApiCallId: string = "";
  searchCustomerByNameApiMessageId: string = "";
  searchCustomerByEmployeeIdApiMessageId: string = "";
  applyPromotionApiCallId: string = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      getCustomEnumName(CustomEnums.CustomActionReducers),
    ];
    // Customizable Area End

    // Customizable Area Start
    this.state = {
      selectedPickUpDate: null,
      selectedDeliveryDate: null,
      cartTotalOpen: false,
      countryCodeInput: "+966",
      customerPhoneNumber: "",
      customerList: [],
      cartProducts: [],
      customerData: null,
      openAddCustomerModal: false,
      errorSnackbarOpen: false,
      errorMessage: "",
      viewCustomerPopup: false,
      isEditCustomerForm: false,
      serviceDropdownList: serviceDropList,
      selectedServiceValue: "",
      isQuickDropCount: 0,
      isQuickDropOrder: false,
      order: undefined,
      paymentModalVisible: false,
      paymentClicked: false,
      notesTextArea: "",
      saveForFuture: false,
      orderSummaryVisible: false,
      placedOrder: undefined,
      isPrmocodeApplied: false,
      prefrenceCustomerNumber: "",
      customerId: "",
      isLoading: false,
      isShoppingcartLoading: false,
      isB2bActive: false,
      checkContractSuccessMsg: "",
      searchedCustomer: null,
      isLinked: true,
      isLinkeds: true,
      isCountryCodeDisabled: false,
      currentInputType: "empty",
      customerNameSearchResults: [],
      addPromotionsModalVisible: false,
    };
    // Customizable Area End

    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  async componentDidMount() {
    super.componentDidMount();
    // Customizable Area Start
    const editId = this.props.navigation.getParam("editId");
    if (editId) {
      this.setState({ editId }, () => {
        this.onCustomerSearch();
        this.getLoundryOrder(editId);
      });
    }
    this.retrieveAccountTypeInfo();
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      if (apiRequestCallId === this.searchCustomerApiMessageId) {
        this.handleCustomerSearchResponse(responseJson);
      } else if (apiRequestCallId === this.searchCustomerDataApiMessageId) {
        this.handleSearchedCustomerDataResponse(responseJson.data);
      } else if (apiRequestCallId === this.getOrderDetailsAPIcallID) {
        this.handleGetOrderDetailsResponse(responseJson.order);
      } else if (apiRequestCallId === this.generateOrderInvoiceCallId) {
        this.generateOrderInvoiceResponse(responseJson);
      } else if (apiRequestCallId === this.getRawOrderInvoiceDataCallId) {
        this.handleRawInvoiceDataResponse(responseJson);
      } else if (apiRequestCallId === this.getRemainBalanceApiCallId) {
        this.handlePayAfterRemainingBalanceResponse(responseJson);
      } else if (apiRequestCallId === this.searchCustomerByNameApiMessageId) {
        this.handleCustomerNameSearchResponse(responseJson);
      } else if (
        apiRequestCallId === this.searchCustomerByEmployeeIdApiMessageId
      ) {
        this.handleEmployeeIdSearchResponse(responseJson);
      }
    } else if (
      getCustomEnumName(CustomEnums.CustomActionReducers) === message.id
    ) {
      this.handleCustomReducer(message);
    }
    // Customizable Area End
  }

  // Customizable Area Start



  handlePayAfterRemainingBalanceResponse = (responseJson: any) => {
    if (!responseJson.is_load) {
      this.handlePayClick();
    } else {
      this.setState({
        errorSnackbarOpen: true,
        errorMessage: responseJson.errors,
      });

      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  };

  retrieveAccountTypeInfo = async () => {
    const isB2b = await getStorageData("accountType");

    if (isB2b === "b2b") {
      this.setState({ isB2bActive: true });
    } else {
      this.setState({ isB2bActive: false });
    }
  };

  handleCustomReducer = (message: Message) => {
    const action = message.getData(
      getCustomEnumName(CustomEnums.CustomReducerAction)
    );
    const payload = message.getData(
      getCustomEnumName(CustomEnums.CustomReducerPayload)
    );

    if (action === "SET_ORDER") {
      this.setState({
        order: payload,
      });
    } else if (action === "CLEAR_CUSTOMER_CART") {
      this.handleClearOrder();
    } else if (action === "CUSTOMER_PHONE") {
      this.setState(
        {
          customerPhoneNumber: payload.option,
          prefrenceCustomerNumber: "",
        },
        () => this.handleCheckMobileNumber(payload)
      );
    } else if (action === "SHOPPING_CART_LOADING") {
      this.setState({
        isShoppingcartLoading: payload,
      });
    } else if (action === "CLEAR_CUSTOMER") {
      this.handleOnChangeCustomerPhone();
    } else if (action === "CHANGE_CUSTOMER_PHONE") {
      this.handleCustomerPhoneNumber(payload);
    } else if (action === "CHANGE_COUNTRY_CODE") {
      this.handleChangeCountryCode(payload);
    } else {
      this.setState({
        isShoppingcartLoading: false,
      });
    }
  };

  handleToggleCartTotal() {
    const { order } = this.state;
    if (order?.no_of_items) {
      this.setState((prev) => ({ cartTotalOpen: !prev.cartTotalOpen }));
    }
  }

  handleChangeCountryCode(value: string) {
    this.setState({
      countryCodeInput: value,
      customerPhoneNumber: "",
    });
  }

  handleCustomerPhoneNumber(value: string) {
    localStorage.removeItem("preferenceCustomer");
    const { customerList, customerData } = this.state;

    // Detect input type and handle country code state
    this.detectInputTypeAndUpdateState(value);

    this.setState({
      checkContractSuccessMsg: "",
      isLinked: true,
      isLinkeds: true,
    });
    if (customerData !== null && customerData.id !== undefined) {
      this.handleOnChangeCustomerPhone();
    }

    const selectedOption = customerList.find(
      (item: { option: string }) => item?.option == value
    );
    if (!this.state.editId) {
      this.setState(
        {
          customerPhoneNumber: value.replace(/^0+/, ""),
          isQuickDropCount: 0,
          isQuickDropOrder: false,
          order: undefined,
          orderSummaryVisible: false,
        },
        () =>
          !value.includes("-")
            ? this.handleSmartCustomerSearch(value)
            : this.handleCheckMobileNumber(selectedOption as CustomerList)
      );
    } else {
      if (value === this.state.customerPhoneNumber) {
        this.setState(
          {
            customerPhoneNumber: value.replace(/^0+/, ""),
            isQuickDropCount: 0,
            isQuickDropOrder: false,
          },
          () =>
            !value.includes("-")
              ? this.handleSmartCustomerSearch(value)
              : this.handleCheckMobileNumber(selectedOption as CustomerList)
        );
      } else {
        navigateTo({ props: this.props, screenName: "OrderCreation" });
      }
    }
  }

  onCustomerSearch() {
    const { countryCodeInput, customerPhoneNumber } = this.state;

    if (String(customerPhoneNumber).length < 7) {
      return;
    }

    const fullNumber = String(countryCodeInput + customerPhoneNumber).replace(
      "+",
      ""
    );

    let apiEndPoint = this.state.isB2bActive
      ? configJSON.bussinessCustomerSearchEndPoint
      : configJSON.customerSearchEndPoint;

    const message = makeApiMessage({
      url: apiEndPoint + "?full_phone_number=" + fullNumber,
      method: configJSON.getApiMethod,
    });
    this.searchCustomerApiMessageId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  handleCustomerSearchResponse(responseJson: CustomerSearchResponse) {
    if (responseJson) {
      const customer_list =
        responseJson.customer?.map((customer) => {
          return {
            id: String(customer.id),
            country_code: String(customer.country_code),
            full_phone_number: customer.full_phone_number,
            option: `${customer.full_name} - ${customer.phone_number}`,
          };
        }) || [];
      this.setState({ customerList: customer_list });
    }
  }

  handleOnChangeCustomerPhone() {
    this.setState({
      customerPhoneNumber: "",
      customerList: [],
      customerData: null,
      isQuickDropCount: 0,
      order: undefined,
      checkContractSuccessMsg: "",
      isLinked: true,
      isLinkeds: true,
      isCountryCodeDisabled: false,
      currentInputType: "empty",
      customerNameSearchResults: [],
    });
    this.handleSendAction("SELECT_CUSTOMER", null);
  }

  handleCheckMobileNumber(searched_customer: CustomerList) {
    if (this.props.currentUser?.attributes?.employee_proifle) {
      const store_management_id =
        this.props.currentUser?.attributes.employee_proifle.data.attributes
          .store_management_id;

      let extraQueryParams = "&cart_order_required=true";
      let store_id = `&store_id=${store_management_id}`;

      if (searched_customer?.full_phone_number) {
        this.setState({ isLoading: true, searchedCustomer: searched_customer });
        const apiEndPoint = this.state.isB2bActive
          ? configJSON.BussinessSearchCustomerApiEndPoint
          : configJSON.searchCustomerApiEndPoint;
        const message = makeApiMessage({
          url:
            apiEndPoint +
            "?full_phone_number=" +
            searched_customer?.full_phone_number +
            extraQueryParams +
            store_id,
          method: configJSON.getApiMethod,
        });
        this.searchCustomerDataApiMessageId = message.messageId;
        runEngine.sendMessage(message.id, message);
      }
    }
  }

  handleCheckMobileNumberForPrefrenceCustomer(searched_customer: CustomerList) {
    const store_management_id = localStorage.getItem("store_id");
    let extraQueryParams = "&cart_order_required=true";
    let store_id = `&store_id=${store_management_id}`;

    if (searched_customer?.full_phone_number) {
      this.setState({ isLoading: true });
      const apiEndPoint = this.state.isB2bActive
        ? configJSON.BussinessSearchCustomerApiEndPoint
        : configJSON.searchCustomerApiEndPoint;
      const message = makeApiMessage({
        url:
          apiEndPoint +
          "?full_phone_number=" +
          searched_customer?.full_phone_number +
          extraQueryParams +
          store_id,
        method: configJSON.getApiMethod,
      });
      this.searchCustomerDataApiMessageId = message.messageId;
      runEngine.sendMessage(message.id, message);
    }
  }

  handleSearchedCustomerDataResponse(customerData: CustomerDataType) {
    if (this.state.prefrenceCustomerNumber) {
      this.setState({
        customerPhoneNumber: this.state.prefrenceCustomerNumber,
        prefrenceCustomerNumber: "",
      });
    }
    const saveForFutureAndNotesPayload = {
      notesTextArea: customerData?.attributes?.saved_notes
        ? customerData.attributes.saved_notes
        : customerData?.attributes?.order?.notes,
      saveForFuture: customerData?.attributes?.order?.save_for_future || false,
      callUpdateApiForSaveForFutureNote: false,
    };
    this.setState(
      {
        customerData: customerData,
        notesTextArea: customerData?.attributes?.saved_notes
          ? customerData.attributes.saved_notes
          : customerData?.attributes?.order?.notes,
        saveForFuture:
          customerData?.attributes?.order?.save_for_future || false,
      },
      () =>
        this.handleSendAction(
          "SET_SAVE_FOR_FUTURE_&_NOTES",
          saveForFutureAndNotesPayload
        )
    );
    this.handleSendAction("SELECT_CUSTOMER", customerData);
    this.handleCustomerQuickDropOrder(
      customerData.attributes.golden_point_orders
    );
    this.setState({ isLoading: false });
  }

  handleGetOrderDetailsResponse = (responseJson: {
    status: string;
    data: { attributes: IlaundryOrder };
  }) => {
    const order = responseJson.data.attributes;
    this.props.resetAllProductQuantities();
    if (
      order.status === "placed" &&
      !(this.state.editId && order.is_quick_drop)
    ) {
      this.props.resetAllProductQuantities();
      this.setState({
        paymentModalVisible: false,
        paymentClicked: false,
        orderSummaryVisible: true,
        order: undefined,
        placedOrder: order,
        cartTotalOpen: false,
        isQuickDropCount: 0,
      });

      this.handleSendAction("SET_ORDER", null);
      this.handleSendAction("REMOVE_TEMP_PRODUCT_AFTER_PLACING_ORDER", null);
    } else if (order.status === "in_cart" && !this.state.editId) {
      this.setState({
        order: order,
      });

      this.handleSendAction("SET_ORDER", order);
    } else {
      if (this.state.editId) {
        if (order.is_quick_drop) {
          order.order_items = [];
        }
        order.is_quick_drop = false;
        order.status = "in_cart";
        order.edit_order = true;

        const selectedOption = {
          country_code: order.customer.country_code,
          full_phone_number: order.customer.full_phone_number,
          id: String(order.id),
          option: `${order.customer.full_name} - ${order.customer.full_phone_number}`,
        };
        const isB2bOrder = !order.account_id;
        if (isB2bOrder !== this.state.isB2bActive) {
          updateAccountType(isB2bOrder);
        }

        this.setState({ order, isB2bActive: isB2bOrder });

        setTimeout(() => {
          this.setState({ prefrenceCustomerNumber: selectedOption.option });
        }, 500);

        this.setState({
          paymentClicked: false,
          orderSummaryVisible: true,
          placedOrder: order,
          customerId: String(order.customer.id),
          customerPhoneNumber: `${order.customer.full_phone_number} - ${order.customer.full_name}`,
          countryCodeInput: String(order.customer.country_code),
        });
        this.handleSendAction("EDIT_SELECT_CUSTOMER", order);
      }
    }
    this.setState({ isLoading: false });
  };

  handleClearOrder = () => {
    const customerData = this.state.customerData as CustomerDataType;
    this.setState({
      orderSummaryVisible: false,
      customerData: null,
      order: undefined,
      placedOrder: undefined,
      isQuickDropOrder: false,
      isQuickDropCount: 0,
      editId: "",
    });
    this.placedOrderRawData = null;
    this.handleOnChangeCustomerPhone();
    this.handleSendAction("SET_ORDER", null);
    if (this.state.editId) {
      navigateTo({ props: this.props, screenName: "OrderCreation" });
      if (customerData) {
        const customerItem = {
          id: customerData.id,
          option: `${customerData.attributes?.full_name} - ${customerData.attributes?.phone_number}`,
          full_phone_number:
            customerData.attributes?.country_code +
            "" +
            customerData.attributes?.phone_number,
          country_code: customerData.attributes?.country_code,
        };
        setTimeout(() => {
          this.handleSendAction("CUSTOMER_PHONE", customerItem);
        }, 1000);
      }
    }
  };

  handleOrderSummaryNewOrder = () => {
    const customerData = this.state.customerData as CustomerDataType;
    if (customerData) {
      const customerItem = {
        id: customerData.id,
        option: `${customerData.attributes?.full_name} - ${customerData.attributes?.phone_number}`,
        full_phone_number:
          customerData.attributes?.country_code +
          "" +
          customerData.attributes?.phone_number,
        country_code: customerData.attributes?.country_code,
      };
      this.setState({
        orderSummaryVisible: false,
        placedOrder: undefined,
        editId: "",
      });
      this.handleCheckMobileNumber(customerItem);
      if (this.state.editId) {
        navigateTo({ props: this.props, screenName: "OrderCreation" });
        setTimeout(() => {
          this.handleSendAction("CUSTOMER_PHONE", customerItem);
        }, 1000);
      }
    }
  };

  handleAddCustomerPopupOpen() {
    const { customerPhoneNumber, countryCodeInput } = this.state;

    this.setState({
      openAddCustomerModal: true,
      customerData: {
        attributes: {
          country_code: countryCodeInput,
          phone_number: customerPhoneNumber,
          payment_type: "",
          gender: "",
          city: "",
          business: "",
        },
      } as CustomerDataType,
    });
  }

  handleOpenAddCustomerPopup() {
    const {
      customerData,
      customerPhoneNumber,
      customerList,
      countryCodeInput,
    } = this.state;
    if (
      customerPhoneNumber &&
      customerList.find(
        (customer: CustomerList) => customer.option === customerPhoneNumber
      )
    ) {
      this.setState({
        errorSnackbarOpen: true,
        errorMessage: configJSON.Strings.customer_phone_already_register,
      });
      return;
    }

    if (customerData == null) {
      this.handleAddCustomerPopupOpen();
    } else if (customerData.id == undefined) {
      this.handleAddCustomerPopupOpen();
    }
  }

  handleCloseAddCustomerPopup() {
    this.setState({
      openAddCustomerModal: false,
      isEditCustomerForm: false,
    });
  }

  handleSnackbarClose(_event?: React.SyntheticEvent, reason?: string) {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      errorSnackbarOpen: false,
      errorMessage: "",
    });
  }

  onSetCustomerFromPopup(customer: unknown) {
    if (typeof customer !== "string") {
      const { full_name, country_code, full_phone_number, customer_id } =
        (customer as {
          full_name: string;
          customer_id: string;
          country_code: string;
          full_phone_number: string;
        }) || {};

      const mobile_number = String(full_phone_number).replace(
        String(country_code).replace("+", ""),
        ""
      );
      const option = `${full_name} - ${mobile_number}`;

      const customerList = {
        option: option,
        id: customer_id,
        country_code: "+" + country_code,
        full_phone_number: full_phone_number,
      };

      this.setState(
        {
          customerList: [customerList],
        },
        () => {
          this.handleCheckMobileNumber(customerList as CustomerList);
          this.setState({
            countryCodeInput: conditionalString(
              country_code,
              `+${country_code}`,
              ""
            ),
            customerPhoneNumber: `${full_name} - ${mobile_number}`,
          });
        }
      );
    }
  }

  handleViewCustomerPopupOpen() {
    const { customerData } = this.state;
    if (customerData !== null && customerData.id) {
      this.setState({
        viewCustomerPopup: true,
      });
    }
  }

  handleCloseViewCustomerPopup = () => {
    this.setState({ viewCustomerPopup: false, isEditCustomerForm: false });
  };

  handleEditCustomerForm() {
    this.setState({
      isEditCustomerForm: true,
      viewCustomerPopup: false,
      openAddCustomerModal: true,
    });
  }

  handleServiceDropdown = (
    event: React.ChangeEvent<{
      value: string;
    }>
  ) => {
    this.setState({
      selectedServiceValue: event.target.value,
    });
  };

  handleOnChangeNotes = (
    event: React.ChangeEvent<{
      value: string;
    }>
  ) => {
    this.setState({
      notesTextArea: event.target.value,
    });
    this.debouncedFetchNotes();
  };

  handleOnCheckedToggle = (checked: boolean) => {
    this.setState(
      {
        saveForFuture: checked,
      },
      () => this.handleSaveForFutureOrder()
    );
  };

  returnQuickDropOrderBody = () => {
    const { isQuickDropCount, customerData, order } = this.state;
    const store_management_id =
      this.props.currentUser?.attributes.employee_proifle.data.attributes
        .store_management_id;

    const customer_Id = this.state.isB2bActive
      ? { business_account_customer_id: customerData?.id }
      : { customer_id: customerData?.id };

    if (order !== undefined) {
      let order_items_attributes = [];
      if (order.order_items.length > 0) {
        order_items_attributes = order.order_items.map((orderItem) => {
          return {
            id: orderItem.attributes.id,
            quantity: isQuickDropCount,
            _destroy: isQuickDropCount == 0 ? true : false,
          };
        });
      } else {
        order_items_attributes = [{ quantity: isQuickDropCount }];
      }
      return {
        data: {
          ...customer_Id,
          notes: "",
          store_management_id: store_management_id,
          save_for_future: false,
          is_quick_drop: true,
          order_items_attributes: order_items_attributes,
        },
      };
    } else {
      return {
        data: {
          ...customer_Id,
          notes: "",
          store_management_id: store_management_id,
          save_for_future: false,
          is_quick_drop: true,
          order_items_attributes: [
            {
              quantity: isQuickDropCount,
            },
          ],
        },
      };
    }
  };

  handleCreateQuickDropOrder = () => {
    const { order } = this.state;

    let apiEndPoint = "";
    let apiMethod = "";

    if (order !== undefined) {
      apiEndPoint = this.state.isB2bActive
        ? configJSON.bussinessUpdateOrderEndPoint + `?id=${order.id}`
        : configJSON.updateOrderEndPoint + order.id;
      apiMethod = "PUT";
    } else {
      apiEndPoint = this.state.isB2bActive
        ? configJSON.bussinessCreateNewOrderEndPoint
        : configJSON.createNewOrderEndPoint;
      apiMethod = "POST";
    }
    let message = makeApiMessage({
      url: apiEndPoint,
      body: JSON.stringify(this.returnQuickDropOrderBody()),
      method: apiMethod,
    });
    this.createQuickdropOrderId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  debouncedFetchCustomQty = debounce(this.handleCreateQuickDropOrder, 500);

  isQuickDropDisabled = () => {
    const { customerData, order } = this.state;
    if (this.state.isB2bActive) {
      return true;
    }
    if (customerData == null) {
      return true;
    } else {
      if (order !== undefined) {
        if (!order.is_quick_drop && order.items.data.length > 0) {
          return true;
        }
      } else {
        return false;
      }
    }
  };

  handleCustomerQuickDropOrder = (customerOrder: IlaundryOrder) => {
    if (customerOrder) {
      const items = customerOrder.items?.data || [];
      const isItemsAvailable = items.length > 0;
      this.setState({
        order: customerOrder,
        isQuickDropOrder: false,
        isQuickDropCount: items.length,
      });
    } else {
      this.setState({
        order: undefined,
        isQuickDropOrder: false,
        isQuickDropCount: 0,
      });
    }
  };

  /**
   * A driver's order for a mobile service request, opened from the Coming to
   * Store tab. The store only corrects its items here: payment, notes and the
   * customer all belong to the request, so the cart hides those and its main
   * button goes back to the request instead of taking payment.
   */
  isMobileRequestOrder() {
    return Boolean(this.state.order?.mobile_service_request_id);
  }

  handleBackToMobileRequest = () => {
    navigateTo({ props: this.props, screenName: "Orders" });
  };

  handlePayButton = () => {
    if (this.isMobileRequestOrder()) {
      this.handleBackToMobileRequest();
      return;
    }
    // const { isQuickDropOrder, isQuickDropCount } = this.state;
    // console.log("isQuickDropOrder",isQuickDropOrder,isQuickDropCount)
    // if(this.state.isB2bActive && !isQuickDropOrder) {
    //   this.b2bConfirmOrderApi();
    // }
    // else if (isQuickDropOrder) {
    //   if (isQuickDropCount > 0 && this.state.isB2bActive) {
    //     this.b2bConfirmOrderApi();
    //   } else if(isQuickDropCount > 0){
    //     this.getRemainBalance();
    //   }
    // } else {
    this.getRemainBalance();
    // }
  };

  async getHeaders() {
    const token = await getStorageData("token");
    return {
      "Content-Type": "application/json",
      token,
    };
  }

  async getRemainBalance() {
    if (!this.state.order) return;
    const { order } = this.state;
    const isStoreOrder = this.props.selectedMainTab == ORDER_TYPES.STORE_ORDER;

    const headers = await this.getHeaders();
    const isEditKey = this.state.editId ? "&edit_order=true" : "";
    const cleaningOrderKeys = !isStoreOrder ? "&unpaid_amount=true" : "";

    const endpoint = !isStoreOrder
      ? configJSON.getRemainingBalanceEndPointForCleaningOrder
      : configJSON.getRemainingBalanceEndPoint;
    const message = makeApiMessage({
      url: endpoint + order?.id + isEditKey + cleaningOrderKeys,
      headers: headers,
      method: "GET",
    });

    this.getRemainBalanceApiCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  getPayButtonEnable() {
    const {
      order,
      isShoppingcartLoading,
      isLinked,
      isB2bActive,
    } = this.state;
    if (isB2bActive && !isLinked) {
      return true;
    }
    // Held while a change is still saving, so leaving cannot drop it.
    if (this.isMobileRequestOrder()) {
      return Boolean(isShoppingcartLoading);
    }
    if (order !== undefined) {
      // else if (order.items.data.length > 0 && !isShoppingcartLoading) {
      //   return false;
      // }
      // else {
      //   return true;
      // }
      return false;
    } else {
      return true;
    }
  }

  handlePayClick = () => {
    const { currentUser } = this.props;
    if (
      currentUser?.attributes?.employee_proifle?.data?.attributes
        ?.store_management?.attributes?.payment_method_screen
    ) {
      this.setState({ paymentModalVisible: true });
    }
  };

  handlePaymentDone = (orderTransantions?: PaymentTransactionData[]) => {
    const { order } = this.state;
    this.setState({
      paymentClicked: true,
      isLoading: true,
      paymentModalVisible: false,
    });
    const orderId = Array.isArray(order) ? order[0]?.id : order?.id;

    if (orderId) {
      this.getRawInvoiceData(orderId);
    }

    this.getLoundryOrder();
    this.handleCheckMobileNumber(this.state.searchedCustomer as CustomerList);
    if (this.state.editId) {
      const selectedOption = {
        country_code: String(order?.customer.country_code),
        full_phone_number: `${order?.customer?.full_phone_number}`,
        id: String(order?.id),
        option: `${
          order?.customer.full_name
        } - ${order?.customer?.full_phone_number.substring(3)}`,
      };
      this.handleCheckMobileNumberForPrefrenceCustomer(selectedOption);
    }
  };

  getLoundryOrder = (editOrderId?: string) => {
    const { order } = this.state;
    let message;
    if (editOrderId) {
      message = makeApiMessage({
        url: configJSON.updateOrderEndPoint + editOrderId,
        method: "GET",
      });
    } else {
      message = makeApiMessage({
        url: configJSON.updateOrderEndPoint + order?.id,
        method: "GET",
      });
    }
    if (editOrderId) {
      this.getOrderDetailsAPIcallID = message.messageId;
      runEngine.sendMessage(message.id, message);
    } else {
      this.getOrderDetailsAPIcallID = message.messageId;
      if (!order?.id) {
        return;
      }
      runEngine.sendMessage(message.id, message);
    }
  };

  getRawInvoiceData = (orderId?: string | number) => {
    const apiMessage = makeApiMessage({
      method: "GET",
      url: configJSON.rawOrderInvoiceData + toString(orderId),
    });
    this.getRawOrderInvoiceDataCallId = apiMessage.messageId;
    this.send(apiMessage);
  };

  handlePaymentModalClose = () => {
    this.setState({
      paymentModalVisible: false,
      paymentClicked: false,
    });
  };

  formatTaxPercentage = () => {
    const { order: laundryOrder } = this.state;
    const order = laundryOrder;

    if (!order) {
      return null;
    }
    let formattedTaxPercentage = "";
    if (order?.tax_percentage) {
      const decimalIndex = order?.tax_percentage.indexOf(".");
      formattedTaxPercentage =
        order?.tax_percentage.slice(0, decimalIndex) + "%";
    }
    return formattedTaxPercentage;
  };

  getPayButtonText() {
    const { isQuickDropOrder, isB2bActive } = this.state;
    if (this.isMobileRequestOrder()) return "Done - Back to Request";
    let text = isQuickDropOrder || isB2bActive ? "Submit" : "Pay";

    return text;
  }

  handleSendAction(action: string, payload?: unknown) {
    let message = new Message(
      getCustomEnumName(CustomEnums.CustomActionReducers)
    );
    message.addData(getCustomEnumName(CustomEnums.CustomReducerAction), action);
    message.addData(
      getCustomEnumName(CustomEnums.CustomReducerPayload),
      payload
    );
    runEngine.sendMessage(message.id, message);
  }

  handlePrintReceipt = (fileUrl?: string | null) => {
    if (fileUrl) {
      const printMessage = new Message(
        getCustomEnumName(CustomEnums.CustomActionReducers)
      );
      printMessage.addData(
        getCustomEnumName(CustomEnums.CustomReducerAction),
        "PRINT_FILE"
      );
      printMessage.addData(
        getCustomEnumName(CustomEnums.CustomReducerPayload),
        {
          format: "pdf",
          data: fileUrl,
        }
      );
      this.send(printMessage);
    }
  };

  handleSaveForFutureOrder = () => {
    const payload = {
      notesTextArea: this.state.notesTextArea,
      saveForFuture: this.state.saveForFuture,
      callUpdateApiForSaveForFutureNote: true,
    };
    this.handleSendAction("SET_SAVE_FOR_FUTURE_&_NOTES", payload);
  };


  handleInputQty = (
    event: React.ChangeEvent<{ value: string }>,
    orderItem: StoreOrderItem
  ) => {
    let specials = /^\d*$/;
    if (specials.test(event.target.value)) {
      const { order } = this.state;
      let tempOrder = JSON.parse(JSON.stringify(order)) as IlaundryOrder;
      const findChangeItemIndex = tempOrder.order_items.findIndex(
        (order_item) => order_item.id == orderItem.id
      );

      if (findChangeItemIndex !== -1) {
        const newQty = Number(event.target.value);

        if (newQty === 0) {
          tempOrder.order_items.splice(findChangeItemIndex, 1);
        } else {
          tempOrder.order_items[findChangeItemIndex].attributes.quantity =
            newQty;
          this.debouncedFetchSearchResults(
            tempOrder.order_items[findChangeItemIndex]
          );
        }
      }

      this.setState({ order: tempOrder });
    } else {
      this.setState({
        errorSnackbarOpen: true,
        errorMessage: "Please enter number only",
      });
    }
  };

  handleCustomChangeQty = (findChangeItem: StoreOrderItem) => {
    this.handleSendAction("ADD_CUSTOM_QTY", findChangeItem);
  };

  debouncedFetchSearchResults = debounce(this.handleCustomChangeQty, 500);

  debouncedFetchNotes = debounce(this.handleSaveForFutureOrder, 600);

  handleQuickDropNullValue = (value: string) => {
    if (this.state.isQuickDropCount == 0 && value == "") {
      return true;
    } else if (this.state.isQuickDropCount == 0 && value == "00") {
      return true;
    } else {
      return false;
    }
  };

  handleChangeQuickInputQty = (event: React.ChangeEvent<{ value: string }>) => {
    if (this.handleQuickDropNullValue(event.target.value)) {
      return;
    }
    let specials = /^\d*$/;
    if (specials.test(event.target.value)) {
      let qtyNumber = Number(event.target.value);
      this.setState({
        isQuickDropCount: qtyNumber,
        isQuickDropOrder: !!qtyNumber,
        isLoading: true,
      });
      this.debouncedFetchCustomQty();
    } else {
      this.setState({
        errorSnackbarOpen: true,
        errorMessage: "Please enter number only",
      });
    }
  };

  cartQtyHandler = (orderItem: IGoldenPointItem, actionKey: string) => {
    const { order } = this.state;

    const tempOrder = JSON.parse(JSON.stringify(order));

    const findChangeItem = tempOrder.items?.data?.find(
      (item: any) =>
        Number(item.attributes.golden_point?.attributes?.id) ===
        Number(orderItem.id)
    );
    if (findChangeItem) {
      let currentQty = Number(findChangeItem.attributes.quantity) || 1;
      if (actionKey === "PLUS") {
        currentQty++;
      } else if (actionKey === "MINUS" && currentQty > 0) {
        currentQty--;
      }
      findChangeItem.attributes.quantity = currentQty;
      const gpId = Number(findChangeItem.attributes.golden_point.attributes.id);

      this.debouncedCartQtyUpdate(tempOrder, Number(findChangeItem.id));

      this.setState({ order: tempOrder });
    }
  };

  handleChangeCartQty = (changedOrder: any, orderId: number) => {
    if (!changedOrder?.items?.data) return;

    const findChangeItem = changedOrder.items.data.find(
      (item: any) => Number(item.id) === Number(orderId)
    );

    if (findChangeItem) {
      this.handleSendAction("UPDATE_CART_QTY", findChangeItem);
    }
  };

  debouncedCartQtyUpdate = debounce(this.handleChangeCartQty, 500);

  debouncedCustomerSearch = debounce(this.onCustomerSearch, 500);

  // Smart customer search methods
  detectInputTypeAndUpdateState = (value: string) => {
    if (!value || value.trim() === "") {
      this.setState({
        currentInputType: "empty",
        isCountryCodeDisabled: false,
        customerNameSearchResults: [],
      });
      return;
    }

    // Check for employee ID prefix (B2B only)
    if (this.state.isB2bActive && value.startsWith("/")) {
      this.setState({
        currentInputType: "employee_id",
        isCountryCodeDisabled: true,
        customerNameSearchResults: [],
      });
      return;
    }

    const isNumeric = /^[\d\s-]+$/.test(value.trim());

    if (isNumeric) {
      this.setState({
        currentInputType: "number",
        isCountryCodeDisabled: false,
        customerNameSearchResults: [],
      });
    } else {
      this.setState({
        currentInputType: "text",
        isCountryCodeDisabled: true,
      });
    }
  };

  handleSmartCustomerSearch = (value: string) => {
    if (!value || value.trim() === "") {
      this.setState({ customerNameSearchResults: [] });
      return;
    }

    if (this.state.currentInputType === "employee_id") {
      // Extract employee ID after "/" prefix
      const employeeId = value.substring(1).trim();
      if (employeeId) {
        this.debouncedEmployeeSearch(employeeId);
      }
    } else if (this.state.currentInputType === "text") {
      // Search by name
      this.debouncedNameSearch(value);
    } else if (this.state.currentInputType === "number") {
      // Search by phone number (existing logic)
      this.debouncedCustomerSearch();
    }
  };

  onCustomerNameSearch = (searchName: string) => {
    if (searchName.length < 2) {
      return;
    }

    const apiEndPoint = this.state.isB2bActive
      ? configJSON.bussinessCustomerSearchEndPoint
      : configJSON.customerSearchEndPoint;

    const message = makeApiMessage({
      url: apiEndPoint + "?full_name=" + encodeURIComponent(searchName.trim()),
      method: configJSON.getApiMethod,
    });

    this.searchCustomerByNameApiMessageId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  handleCustomerNameSearchResponse = (responseJson: CustomerSearchResponse) => {
    if (responseJson) {
      const customer_list =
        responseJson.customer?.map((customer) => {
          return {
            id: String(customer.id),
            country_code: String(customer.country_code),
            full_phone_number: customer.full_phone_number,
            option: `${customer.full_name} - ${customer.phone_number}`,
          };
        }) || [];

      this.setState({
        customerNameSearchResults: customer_list,
        customerList: customer_list,
      });
    }
  };

  debouncedNameSearch = debounce(this.onCustomerNameSearch, 500);

  onEmployeeIdSearch = (employeeId: string) => {
    if (!employeeId || employeeId.length < 1) {
      return;
    }

    // Only for B2B customers
    if (!this.state.isB2bActive) {
      return;
    }

    const apiEndPoint = configJSON.bussinessCustomerSearchEndPoint;

    const message = makeApiMessage({
      url: apiEndPoint + "?employee_id=" + encodeURIComponent(employeeId),
      method: configJSON.getApiMethod,
    });

    this.searchCustomerByEmployeeIdApiMessageId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  debouncedEmployeeSearch = debounce(this.onEmployeeIdSearch, 500);

  handleEmployeeIdSearchResponse = (responseJson: CustomerSearchResponse) => {
    if (responseJson) {
      const customer_list =
        responseJson.customer?.map((customer) => {
          return {
            id: String(customer.id),
            country_code: String(customer.country_code),
            full_phone_number: customer.full_phone_number,
            option: `${customer.full_name} - ${customer.phone_number} (Employee ID)`,
          };
        }) || [];

      this.setState({
        customerList: customer_list,
        customerNameSearchResults: customer_list,
      });
    }
  };

  // Method to get country code disabled state for UI
  getCountryCodeDisabled = () => {
    return this.state.isCountryCodeDisabled;
  };

  handleGenerateOrderInvoice = () => {
    const { order } = this.state;

    let message = makeApiMessage({
      url: configJSON.generateOrderInvoiceEndPoint + order?.id,
      method: "GET",
    });
    this.generateOrderInvoiceCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  generateOrderInvoiceResponse = (response: {
    status: number;
    invoice_receipt_pdf_url: string;
  }) => {
    if (response.status == 200) {
      if (response.invoice_receipt_pdf_url) {
        // print the receipt
        this.handlePrintReceipt(response.invoice_receipt_pdf_url);

        // set receipt URL in order to print from order summary
        const { placedOrder } = this.state;
        if (placedOrder) {
          const tempPlaceOrder = JSON.parse(
            JSON.stringify(placedOrder)
          ) as IlaundryOrder;
          tempPlaceOrder.invoice_receipt_pdf_url =
            response.invoice_receipt_pdf_url;
          this.setState({ placedOrder: tempPlaceOrder });
        }
      } else {
        this.setState({
          errorSnackbarOpen: true,
          errorMessage: "Something wrong with priniting, Please try again",
        });
      }
    } else {
      this.setState({
        errorSnackbarOpen: true,
        errorMessage: "Print Error",
      });
    }
  };

  handleRawInvoiceDataResponse = (response?: { data?: InvoiceRawData }) => {
    this.placedOrderRawData = response?.data || null;
    if (response?.data) {
      const printMessage = new Message(
        getCustomEnumName(CustomEnums.CustomActionReducers)
      );
      printMessage.addData(
        getCustomEnumName(CustomEnums.CustomReducerAction),
        "GOLDEN_POINT_PRINT_RECEIPT"
      );
      printMessage.addData(
        getCustomEnumName(CustomEnums.CustomReducerPayload),
        response.data
      );
      this.send(printMessage);
    } else {
      this.setState({
        errorMessage: "unable to fetch order data",
        errorSnackbarOpen: true,
      });
    }
  };



  // Customizable Area End
}
